<template>
  <div>
    <Header></Header>

    <!-- PAGE HEADER -->
    <div class="page-header parceiros">
      <div class="container">
        <div class="row">
          <div class="col-md-offset-1 col-md-10 text-center">
            <h1 class="text-uppercase">Parceiros e Apoio</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- /PAGE HEADER -->

    <!-- SECTION -->
    <div class="section">
      <!-- container -->
      <div class="container">
        <!-- row -->
        <div class="row">
          <div class="col-md-12">
            <div class="section-row">
              <div class="section-title">
                <h2 class="title">PEDLINE</h2>
              </div>
              <p>
                O trabalho e a dedicação de competentes profissionais do Site
                Pedline contribuiu para a criação de uma organização pioneira no
                país voltada para a prevenção primária de doenças que ajudarão
                os pacientes a entender melhor o problema de seu filho(a)
                durante seu desenvolvimento da concepção até a adolescência.
                Para atingir e auxiliar de alguma forma um número cada vez maior
                de usuários da internet contamos com a ajuda de nossos
                parceiros:
              </p>
            </div>
            <div class="flex-column-center section-title gap col-md6">
              <h2 class="title">Realização:</h2>
              <div class="sponsor-holder">
                <a
                  href="http://smcc.com.br/home"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    src="../assets/images/patrocinio/smcc.jpg"
                    class="patrocinio"
                  />
                </a>
              </div>
            </div>

            <div class="section-title gap col-md6 mt-2">
              <h2 class="title">Apoio:</h2>
              <div class="flex-start flex-vertical-center">
                <a
                  href="http://www.acdc.com.br/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    src="../assets/images/patrocinio/acdc.png"
                    class="patrocinio mt-1"
                  />
                </a>
                <a
                  href="https://www.portalped.com.br/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    style="margin-left:35px;"
                    src="../assets/images/patrocinio/portalped.png"
                    class="patrocinio mt-1"
                  />
                </a>
                <a
                  href="https://www.slowmedicine.com.br/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    src="../assets/images/patrocinio/slowmedicine.jpg"
                    class="patrocinio mt-1"
                    style="width:210px;margin-left:35px;"
                  />
                </a>
                <a
                  href="https://www.unimedcampinas.com.br/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    src="../assets/images/patrocinio/unimed.png"
                    class="patrocinio mt-1"
                    style="margin-left:35px;"
                  />
                </a>
                <a
                  href="https://royalpalm.com.br/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    src="../assets/images/patrocinio/royal.jpg"
                    class="patrocinio mt-1"
                    style="margin-left:15px;width:210px"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /SECTION -->

    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../components/Header";
import Footer from "../components/Footer";

export default {
  name: "Parceiros",
  components: {
    Header,
    Footer
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Parceiros.vue